import { Injectable } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { HttpClient } from "@angular/common/http";
import { ApiService } from './api.service';
import { Promise } from 'q';
import { error } from 'util';


@Injectable()
export class DataService {
  // userType = 'Consumer';
  // fakeReport = true;
  // hub = false;
  // subMenuEnterPrice = true;

  productForm = {};
  productResponse = [];
  userDetails = {};
  user_id = {};
  // emailVerified: boolean;

  userConsumer = true;
  userOutletSupervisor = false;
  userCompanyAdmin = false;


  // userNameFirst = {};
  // userNameLast = {};
  countriesList = [];
  selectedCountryName = '';
  selectCountryCode = '';
  selectCountryDial = '';

  currencyList = [];
  selectedCurrencyName = '';
  selectCurrencyCode = '';
  selectCurrencyDial = '';

  currencyPlaceholder = true;
  countryPlaceholder = true;
  otpSendEmail = '';
  otpSendPhone = '';
  isEmail = true;

  productSpamInfo = false;
  unreadCount = 0;
  transactionCount = 0;
  loading = false;

  userForm = {};
  otpData = {};
  oldPhoneNumber = "";
  oldEmail = "";
  oldCountry = "";
  ean = '';

  constructor(
    private stateService: StateService,
    private http: HttpClient,
    private apiService: ApiService
  ) {

    this.getLoginUserDetails();
    this.menuOptions();

    // this.logService.printLog("user details -", this.userDetails);

    this.getCountryData();
    this.getCurrencyData();
  }

  getLoginUserDetails() {
    if (localStorage.getItem('user') !== null) {
      this.userDetails = JSON.parse(localStorage.getItem('user'));
      // this.userDetails = JSON.parse(localStorage.getItem('user')).profile.first_name;
      // this.userDetails = JSON.parse(localStorage.getItem('user')).profile.last_name;
      this.user_id = { 'user_id': this.userDetails['user_id'] };
      // this.emailVerified = this.userDetails['profile'].emailVerified;
    } else {
      this.stateService.go('landing');
    }
    // this.logService.printLog(this.userDetails, 'logged in');
  }

  /*
      GET USERPROFILE DATA
  */
  getUserprofiledata() {
    const userProfile = {
      "user_id": this.userDetails["user_id"]
    };
    this.loading = true;
    this.apiService.getUserProfile(userProfile, (response) => {
      this.loading = false;
      // this.logService.printLog("User profile received - ", response);
      this.oldPhoneNumber = response.phone_number;
      this.oldEmail = response.email;
      this.oldCountry = response.countryCode;
      this.userForm = response;
      if(this.userDetails.hasOwnProperty("profile")) {
        this.userDetails["profile"].mobileVerified = this.userForm['mobileVerified'];
        this.userDetails["profile"].emailVerified = this.userForm['emailVerified'];
      }

      // this.emailVerified = this.userDetails['profile'].emailVerified;
      //  this.logService.printLog("check email verify -", this.emailVerified);

      console.log("update profile data userform-", this.userForm);
      // this.logService.printLog("countryCode here -", response.countryCode);
      this.countriesList.forEach((country) => {
        if (country.dial_code === ("+" + response.countryCode)) {
          this.selectCountryCode = country.code;
          this.selectCountryDial = country.dial_code;
          this.selectedCountryName = country.name;
        }
      });
    });
  }

  /* User local storage update when changes in profile */
  setProfile() {
    localStorage.setItem('user', "");
    localStorage.setItem('user', JSON.stringify(this.userDetails));
  }

  menuOptions() {
    switch (this.userDetails['group']) {

      case 'Signet User':
        this.userConsumer = true;
        this.userOutletSupervisor = false;
        this.userCompanyAdmin = false;
        break;

      case 'Outlet Supervisor':
        this.userConsumer = false;
        this.userOutletSupervisor = true;
        this.userCompanyAdmin = false;
        break;

      case 'Company Admin':
        this.userConsumer = false;
        this.userOutletSupervisor = false;
        this.userCompanyAdmin = true;
        break;
    }
  }

  getCountryData() {
    this.http.get("assets/country.json")
      .subscribe(response => {
        // this.logService.printLog("Countries list response - ", response);
        for (const key in response) {
          this.countriesList.push(response[key]);
        }
      });
  }

  getCurrencyData() {
    this.http.get("assets/currency.json")
      .subscribe(response => {
        // this.logService.printLog("currency list response - ", response);
        for (const key in response) {
          this.currencyList.push(response[key]);
        }
      });
  }

  clearData() {
    this.oldPhoneNumber = "";
    this.oldEmail = "";
    this.oldCountry = "";
    this.userForm = {};
    this.userDetails = {};
    this.selectCountryCode = "";
    this.selectCountryDial = "";
    this.selectedCountryName = "";
    localStorage.clear();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/services/data.service.ts